import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import logo from '../assets/images/logo.png';
import { CONTACT } from '../data/services';

const NAV_LINKS = [
  { label: 'บริการ', hash: '#services', icon: 'medical_services' },
  { label: 'เกี่ยวกับเรา', hash: '#about', icon: 'favorite' },
  { label: 'ทีมงาน', hash: '#staff', icon: 'groups' },
  { label: 'ประกาศ', hash: '#news', icon: 'campaign' },
  { label: 'การเดินทาง', hash: '#access', icon: 'place' },
];

function NavBar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 60);
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // ルート遷移したらメニューを閉じる
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  const closeMenu = useCallback(() => setIsMenuOpen(false), []);

  const goTo = (hash) => (e) => {
    e.preventDefault();
    closeMenu();
    if (location.pathname !== '/') {
      navigate(`/${hash}`);
      return;
    }
    if (!hash) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    document.querySelector(hash)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
    <header className={`site-header ${isScrolled ? 'scrolled' : ''}`}>
      <nav aria-label="เมนูหลัก">
        <a href="/" className="logo" onClick={goTo('')}>
          <img src={logo} alt="" className="logo-image" />
          <span>Pet Direct Hospital</span>
        </a>

        <ul id="main-menu" className={isMenuOpen ? 'active' : ''}>
          {NAV_LINKS.map((link) => (
            <li key={link.hash}>
              <a href={`/${link.hash}`} onClick={goTo(link.hash)}>
                <span className="material-icons" aria-hidden="true">{link.icon}</span>
                {link.label}
              </a>
            </li>
          ))}
          <li className="menu-contact">
            <a href={CONTACT.phoneHref} onClick={closeMenu} className="nav-phone">
              <span className="material-icons" aria-hidden="true">call</span>
              {CONTACT.phone}
            </a>
          </li>
          <li className="menu-contact">
            <a
              href={CONTACT.lineUrl}
              target="_blank"
              rel="noopener noreferrer"
              onClick={closeMenu}
              className="nav-cta"
            >
              <span className="material-icons" aria-hidden="true">chat</span>
              จองคิวผ่าน LINE
            </a>
          </li>
        </ul>

        <div className="nav-actions">
          <a href={CONTACT.phoneHref} className="nav-phone" aria-label={`โทร ${CONTACT.phone}`}>
            <span className="material-icons" aria-hidden="true">call</span>
            <span className="nav-phone-number">{CONTACT.phone}</span>
          </a>
          <a
            href={CONTACT.lineUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="nav-cta"
          >
            <span className="material-icons" aria-hidden="true">chat</span>
            จองคิว LINE
          </a>
          <button
            type="button"
            className={`hamburger ${isMenuOpen ? 'active' : ''}`}
            onClick={() => setIsMenuOpen((open) => !open)}
            aria-expanded={isMenuOpen}
            aria-controls="main-menu"
            aria-label={isMenuOpen ? 'ปิดเมนู' : 'เปิดเมนู'}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </nav>
    </header>
    {/* ヘッダー内に置くとbackdrop-filterの影響でfixedが効かないため外に出す */}
    {isMenuOpen && <div className="menu-backdrop" onClick={closeMenu} aria-hidden="true" />}
    </>
  );
}

export default NavBar;
